// extracted by mini-css-extract-plugin
export default {"root":"DataversePage_root__LoTu9"};